import { TableCell } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  tableDataRow: {},
}));

function MatxTableCell({ ...props }) {
  const classes = useStyles();
  return (
    <TableCell
      className={`${classes.tableDataRow} ${props.className}`}
      align={props.align ? props.align : "center"}
      key={props.key}
    >
      {props.children}
    </TableCell>
  );
}

export default MatxTableCell;
